const styles = {
  dl: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0,
    margin: 0,
  },
  dt: {
    padding: 0,
    margin: 0,
  },
  dd: {
    padding: 0,
    margin: 0,
  },
  ddtestid: {
    "& span.MuiChip-root": { marginLeft: 0 },
  },
};

export default styles;
